import { render, staticRenderFns } from "./vehicleRealTimeData.vue?vue&type=template&id=4d129f4d&scoped=true&"
import script from "./vehicleRealTimeData.vue?vue&type=script&lang=js&"
export * from "./vehicleRealTimeData.vue?vue&type=script&lang=js&"
import style0 from "./vehicleRealTimeData.vue?vue&type=style&index=0&id=4d129f4d&prod&scoped=true&lang=less&"
import style1 from "./vehicleRealTimeData.vue?vue&type=style&index=1&id=4d129f4d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d129f4d",
  null
  
)

export default component.exports